import axios from "axios";

export function getLocalAccessToken() {
  const accessToken = window.localStorage.getItem("accessToken");
  return accessToken;
}

function getLocalRefreshToken() {
  const refreshToken = window.localStorage.getItem("refreshToken");
  return refreshToken;
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  async (config) => {
    if (config.url?.includes("/api/iam/refresh-token")) {
      const refreshToken = getLocalRefreshToken();
      console.log("Refresh token in request: " + refreshToken);
      if (refreshToken) {
        config.headers["Authorization"] = `Bearer ${refreshToken}`;
      }
    } else {
      const token = getLocalAccessToken();
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (err.response) {
      // Access Token is expired
      if (err.response.status === 401 && !originalConfig._isRetry) {
        originalConfig._isRetry = true;

        try {
          const rs = await getRefreshToken();
          console.log("rs", rs);

          const responseData: string = rs.data.responseData;

          const accessTokenMatch = responseData.match(/accessToken=([^,]+)/);
          const refreshTokenMatch = responseData.match(/refreshToken=([^,]+)/);

          if (accessTokenMatch) {
            const accessToken = accessTokenMatch[1].replace(/[)}\]]$/, "");
            console.log("accessToken", accessToken);
            window.localStorage.setItem("accessToken", accessToken || "");
          }

          if (refreshTokenMatch) {
            // Remove any trailing characters after the token value
            const refreshToken = refreshTokenMatch[1].replace(/[)}\]]$/, "");
            console.log("refreshToken", refreshToken);
            localStorage.removeItem("refreshToken");
            window.localStorage.setItem("refreshToken", refreshToken || "");
          }

          return instance(originalConfig);
        } catch (_error: any) {
          if (_error.response && _error.response.data) {
            return Promise.reject(_error.response.data);
          }

          return Promise.reject(_error);
        }
      }

      if (err.response.status === 403 && err.response.data) {
        return Promise.reject(err.response.data);
      }
    }

    return Promise.reject(err);
  }
);

function getRefreshToken() {
  const refreshTokenValue = getLocalRefreshToken();
  console.log(
    "Getting refresh token using current token: " + refreshTokenValue
  );
  return instance.post("/api/iam/refresh-token", {
    headers: {
      Authorization: `Bearer ${refreshTokenValue}`,
    },
  });
}

export default instance;
